module.exports = __webpack_public_path__ + "img/tratamiento-posicional.5866f4cb.jpg";